import "../CSS/game.css";

export function createGameContainer(diff) {
  const gameplay = document.getElementById("gameplay");
  const gameCreate = document.createElement("div");
  gameCreate.classList = "container";
  gameCreate.id = "game";
  gameCreate.style.display = "block";
  gameCreate.style.textAlign = "center";
  gameplay.appendChild(gameCreate);

  // Header //
  const header = document.createElement("div");
  header.classList = "game-header";
  gameCreate.appendChild(header);

  // header buttons //
  const divButtons = document.createElement("div");
  divButtons.classList = "header-buttons";
  header.appendChild(divButtons);

  const backToMenu = document.createElement("button");
  backToMenu.innerText = "Grįžti į meniu";
  backToMenu.id = "backToMenu";
  divButtons.appendChild(backToMenu);

  const table = document.createElement("button");
  table.innerText = "Rezultatai";
  table.id = "table";
  table.classList = "button";
  divButtons.appendChild(table);

  const shuffleImage = document.createElement("button");
  shuffleImage.innerText = "Pakeisti nuotrauką";
  shuffleImage.id = "shuffle-image";
  shuffleImage.classList = "button";
  divButtons.appendChild(shuffleImage);

  const shuffle = document.createElement("button");
  shuffle.innerText = "Maišyti";
  shuffle.id = "shuffle";
  shuffle.classList = "button";
  divButtons.appendChild(shuffle);

  // header clicker & hint //
  const divHints = document.createElement("div");
  divHints.classList = "header-hints";
  header.appendChild(divHints);

  const clicker = document.createElement("div");
  clicker.innerText = "Atlikote paspaudimų: 0";
  clicker.id = "clicker";
  divHints.appendChild(clicker);

  const hint = document.createElement("i");
  hint.classList = "fa fa-question-circle fa-lg check";
  divHints.appendChild(hint);

  const image = document.createElement("img");
  image.classList = "show-image";
  image.id = "hintImg";
  image.src = "/IMG/1.jpg";
  image.alt = "image";
  divHints.appendChild(image);

  // canvas //
  const canvas = document.createElement("canvas");
  canvas.id = "canvas";
  gameCreate.appendChild(canvas);

  // footer //

  const footer = document.createElement("div");
  footer.classList = "game-footer";
  gameCreate.appendChild(footer);

  const footerText = document.createElement("div");
  footer.appendChild(footerText);

  const setupadPage = document.createElement("a");
  setupadPage.classList = "aHref";
  setupadPage.href = "https://setupad.com/";
  setupadPage.innerText = "Setupad Games";
  setupadPage.target = "_blank";

  const poweredBySetupAd = document.createElement("p");
  poweredBySetupAd.style.fontSize = "15px";
  poweredBySetupAd.innerHTML = `-Powered by ${setupadPage.outerHTML}.`;
  footerText.appendChild(poweredBySetupAd);

  const welovelithuaniaPage = document.createElement("a");
  welovelithuaniaPage.classList = "aHref";
  welovelithuaniaPage.href = "https://welovelithuania.com/";
  welovelithuaniaPage.innerText = "welovelithuania.com";
  welovelithuaniaPage.target = "_blank";

  const weLoveLithuania = document.createElement("p");
  weLoveLithuania.style.fontSize = "15px";
  weLoveLithuania.innerHTML = `-Photos supplied by ${welovelithuaniaPage.outerHTML}.`;
  footerText.appendChild(weLoveLithuania);

  // solved //
  const solved = document.createElement("div");
  solved.id = "solved";
  solved.classList = "solved-canvas";
  gameCreate.appendChild(solved);

  const results = document.createElement("div");
  results.classList = "solved-canvas-results";
  solved.appendChild(results);

  const divElement = document.createElement("div");
  results.appendChild(divElement);

  const h2 = document.createElement("h2");
  h2.innerText = "Sveikinu!";
  divElement.appendChild(h2);

  const difficulty = document.createElement("h3");

  switch (diff) {
    case "3":
      difficulty.innerText = `lengvas sunkumas`;
      break;

    case "4":
      difficulty.innerText = `vidutinis sunkumas`;
      break;

    case "5":
      difficulty.innerText = `sunkus sunkumas`;
      break;

    case "6":
      difficulty.innerText = `Ekspertas`;
      break;
  }

  difficulty.id = `difficulty-selected`;
  difficulty.dataset.value = `${diff}x${diff}`;
  divElement.appendChild(difficulty);

  const bestScore = document.createElement("p");
  bestScore.classList = "result-BestScore";
  divElement.appendChild(bestScore);

  const score = document.createElement("p");
  score.classList = "result-score";
  divElement.appendChild(score);
}
